var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_60",
    "data-name": "Group 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.372,
    height: 54.372,
    viewBox: "0 0 54.372 54.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 54.372,
    height: 54.372,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M54.372,27.186A27.186,27.186,0,1,1,27.186,0,27.186,27.186,0,0,1,54.372,27.186",
    transform: "translate(0 0)",
    fill: "#23292f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M43.564,15.48h5.5L37.618,26.814a10.7,10.7,0,0,1-15.013,0L11.152,15.48h5.507l8.7,8.607a6.765,6.765,0,0,0,9.505,0Z",
    transform: "translate(-2.918 -4.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M16.558,53.031H11.051l11.52-11.4a10.7,10.7,0,0,1,15.013,0L49.1,53.031H43.6l-8.77-8.681a6.764,6.764,0,0,0-9.506,0Z",
    transform: "translate(-2.892 -10.088)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.59755c64b47402101c42d68c9d537ad9.svg";
export { ForwardRef as ReactComponent };